// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_ec4","cls2":"ClaimEvaluationRow-cls2_lEB ClaimEvaluationRow-cls1_ec4","expanded":"ClaimEvaluationRow-expanded_sIi"};